import { Grid } from "@mui/material";
import { FunctionComponent } from "react";

import { Facilitator } from "./facilitator";

export const FacilitatorHome: FunctionComponent = () => {
  return (
    <Facilitator>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={3}>
          
        </Grid>
        <Grid item xs={3}>
          
        </Grid>
        <Grid item xs={3}>
         
        </Grid>
        <Grid item xs={3}>
         
        </Grid>
      </Grid>
    </Facilitator>
  );
};
